import { FunctionComponent, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PropertyDetailsObj } from "../../Models/PropertyDetailsObj";
import { SharePropertyById } from "../../Services/Properties";
import PropertyDesc from "./property-desc";
import "react-image-gallery/styles/css/image-gallery.css";
import ListImageGallery from "../listing-ceation/MarketingAssests/list-image-gallery";
import { Helmet } from 'react-helmet';

const ShareProperty: FunctionComponent<{}> = (props) => {

    let location = useLocation();
    const idValue = location.pathname.split('/');
    const [property, setProperty] = useState<PropertyDetailsObj | undefined>(undefined);
    const [loading, setLoading] = useState(true);
    const [selectedLang, setSelectedLang] = useState("");

    useEffect(() => {
        const id: any = idValue[2];
        SharePropertyById(id).then((data) => {
            setProperty(data)
            setLoading(false);
            setSelectedLang(data.content.description[0]?.lang);
        }).catch((error) => {
            console.log(error)
        })
    }, [])

    const capitalizeFirstLetter = (word: any) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    const capitalizeWordsInSentence = (offeringType: any) => {
        const offeringTypeValue = offeringType.replace('-', ' ')
        const words = offeringTypeValue.split(' ');
        const capitalizedWords = words.map(capitalizeFirstLetter);
        return capitalizedWords.join(' ');
    }

    return loading ? (<div className="container-xxl flex-grow-1 container-p-y"> Loading ...</div>) : (
        <div className="" style={{
            background: "#ffffff", height: "100vh", overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: " #D1D5DB transparent",
        }}>
            <div className="container-xxl flex-grow-1">

                <Helmet>
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={`https://dash.coralytics.com${location.pathname}`} />
                    <meta property="og:title" content={property
                        ? `${property?.content?.propertyType ? capitalizeWordsInSentence(property?.content?.propertyType) : ""} ${property?.content?.offeringType ? capitalizeWordsInSentence(property?.content?.offeringType) : ""} in ${property.content?.address?.subCommunity} ${parseFloat(property.content?.price?.amount).toLocaleString('en-US')} ${property.content?.price?.currency}`
                        : ''} />
                    <meta property="og:description" content={property
                        ? `Bedrooms: ${property.content?.bedroom} Bathrooms: ${property.content?.bathroom} Size: ${property.content?.size?.builtUp} ${property.content?.size?.unit}`
                        : ''} />
                    <meta property="og:image" content={property?.content?.images?.[0]?.src || ''} />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="630" />
                    <meta property="og:image" content={property?.content?.images?.[0]?.src || ''} />
                    <meta property="og:image:width" content="400" />
                    <meta property="og:image:height" content="400" />
                </Helmet>

                <div className="row">
                    <div className="col-md-12">
                        <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">
                            {property?.content?.description && <div className="dropdown">
                                <button
                                    className="btn dropdown-toggle para-14 color-black bold-500"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img src="/assets/images/icons/language-svgrepo-com.svg" width="21" className="marg-right-10" alt="lang" />
                                    {selectedLang && selectedLang.charAt(0).toUpperCase() + selectedLang.slice(1)}
                                    <svg width="14" height="15" viewBox="0 0 14 15" className="marg-left-5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_519_427)">
                                            <path d="M3.5 5.75L7 9.25L10.5 5.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_519_427">
                                                <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                </button>

                                <ul className="dropdown-menu text-center" aria-labelledby="dropdownMenuButton">
                                    {property?.content.description && property.content.description.map((language: any) => (
                                        <li key={language.lang}>
                                            <button
                                                className="dropdown-item text-center"
                                                onClick={() => setSelectedLang(language.lang)}
                                            >
                                                {language.lang.charAt(0).toUpperCase() + language.lang.slice(1)}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>}
                        </div>
                        <div className="sliderProp">
                            <ListImageGallery images={property?.content?.images} />
                        </div>
                        <PropertyDesc property={property ?? {}} lang={selectedLang} />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ShareProperty;